export default "__VITE_ASSET__2d4baf55__"